"use client";

import { Definitions } from "@asosteam/asos-web-datalayer";
import { usePathname } from "next/navigation";
import { useReportWebVitals } from "next/web-vitals";
import { useState, useEffect } from "react";
import { useAnalytics } from "./initialise-analytics";

export const useWebVitalsAnalytics = () => {
  const { pushToDataLayer } = useAnalytics();
  const pathName = usePathname();
  const [firstContentfulPaint, setFirstContentfulPaint] = useState(null);
  const [timeToFirstByte, setTimeToFirstByte] = useState(null);

  useReportWebVitals((metric) => {
    switch (metric.name) {
      case "FCP": {
        setFirstContentfulPaint(metric.value);
        break;
      }
      case "TTFB": {
        setTimeToFirstByte(metric.value);
        break;
      }
    }
  });

  useEffect(() => {
    if (!firstContentfulPaint) {
      return;
    }

    pushToDataLayer({
      firstContentfulPaintData: {
        value: Math.round(firstContentfulPaint),
      } as Definitions["firstContentfulPaintData"],
    });
  }, [firstContentfulPaint, pathName, pushToDataLayer]);

  useEffect(() => {
    if (!timeToFirstByte) {
      return;
    }

    pushToDataLayer({
      timeToFirstByteData: {
        value: Math.round(timeToFirstByte),
      } as Definitions["timeToFirstByteData"],
    });
  }, [timeToFirstByte, pathName, pushToDataLayer]);
};
